import React, { useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import "./SelfieStepper.css"
import LanguageTranslater from '../../HOC/LanguageTranslater';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
    step: {
      "&$completed": {
        color: "green"
      },
      "&$active": {
        color: "#555"
      },
    },
    alternativeLabel: {},
    active: {},
    completed: {},
    labelContainer: {
      "&$alternativeLabel": {
        marginTop: 0
      },
    },

  }),
);

function getSteps(isNps, hybridPosv, twoStep, journeyBy) {

  if (isNps && isNps == 'Y' || journeyBy == "P") {
    return [
      <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>OTP verification</p>];
  } else if (hybridPosv && hybridPosv == 'Y') {
    return [<p style={{ color: '#555', textAlign: 'left', padding: '0' }}>Photo Verification</p>,
    <p style={{ color: '#555', textAlign: 'left' }}>
      Policy Related Questions</p>,
    <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>Video Consent Recording</p>,
    <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>OTP verification</p>];
  } else if (twoStep && twoStep == 'Y') {
    return [
      <p style={{ color: '#555', textAlign: 'left' }}>
        Policy Related Questions</p>,
      <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>OTP verification</p>];
  }
  else {
    return [<p style={{ color: '#555', textAlign: 'left', padding: '0' }}>Photo Verification</p>,
    <p style={{ color: '#555', textAlign: 'left' }}>
      Policy Related Questions</p>,
    <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>OTP verification</p>];
  }

}



const SelfieStepper = (props) => {
  const classes = useStyles();
  const [activeStep] = React.useState(props.currentStep);
  console.log(activeStep);
  console.log(props.currentStep);
  const steps = getSteps(props.isNps, props.hybridPosv, props.twoStep, props.journeyBy);



  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation={props.orientation}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconProps={{
                classes: {
                  root: classes.step,
                  completed: classes.completed,
                  active: classes.active,
                  disabled: classes.disabled
                }
              }}
            >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

export default LanguageTranslater(SelfieStepper)
